import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../store/processAspect/actions';
import pageComponent from './page';
import { StoreState } from '../../store';

export default connect(
  (state: StoreState) => ({
    ...state.processAspects
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(pageComponent);
